/* eslint-disable */
import MetricOperations from "./MetricOperations";
import { DateOut, dateUtility, safeGet, abbreviateNumber, parseJson } from "../utils";
import { IsTabHidden } from "src/shared/utils/customTab";

export interface Filter {
  field: string;
  value: string[];
}

export interface IChartData {
  slice_id: number;
  filters: {
    adhoc_filters: Array<{ [key: string]: string | string[] }>;
    chronic_filters: { [key: string]: string };
  };
  data?: any;
}
interface IPrepareDataAPICall {
  id: number;
  label: string;
  filters: Array<{ [key: string]: string | string[] }> | string;
  performanceChartIds: number[];
  currentChartId: number;
  pastChartId: number;
  offset: number;
  trendChartId: number;
  notes: Notes[];
}
export interface INote {
  id: number;
  label: string;
  filters: Array<{ [key: string]: string | string[] }> | string;
  formatedFilterData: string;
  performanceChartIds: number[];
  currentChartId: number;
  trendChartId: number;
  pastChartId: number;
  notes: Notes[];
  bigNumber: string | undefined;
  vCompare: string | undefined;
  progress?: boolean;
  offset: number;
  allChartsData: IChartData[];
  setChartsData: (data: IChartData[]) => void;
  setNumbers: (timeTab: string) => void;
  successful?: boolean;
  isPositive?: boolean;
  //prepareAPICallData: (data: INote | null) => IPrepareDataAPICall | null;
}

export interface Notes {
  id: number;
  text: string;
  updatedAt: string;
  snapshotDetail: string | undefined;
  dateOut: DateOut;
  offset: number;
}

const comparePrefix = {
  Today: "% WOW",
  Yesterday: "% WOW",
  "Last 7 days": "% change",
  "Last 4 weeks": "% change",
};
const comparePrefixPercent = {
  Today: "% pts WOW",
  Yesterday: "% pts WOW",
  "Last 7 days": "% pts change",
  "Last 4 weeks": "% pts change",
};

export default class NoteModel extends MetricOperations implements INote {
  public id: number;
  public label: string;
  public filters: { [key: string]: string[] }[];
  public offset: number;
  public performanceChartIds: number[];
  public trendChartId: number;
  public pastChartId: number;
  public currentChartId: number;
  public bigNumber: string | undefined;
  public vCompare: string | undefined;
  public progress: boolean;
  public allChartsData: IChartData[];
  public formatedFilterData: string;
  public notes: Notes[] | any;
  public successful?: boolean;
  public isPercentage: boolean;
  public isAnomalous: 0 | 1 | 2;
  public isStaleMetric: string;
  public isPositive: boolean;
  public lowerBound: number;
  public upperBound: number;
  public owner: string;
  public dataset: string;
  public freshness: number;
  public sla: number;
  public time_stamp: string;
  public isHidden: string;
  public message: string;

  public constructor(obj: any) {
    super();
    this.id = obj.id;
    this.label = obj.label;
    this.filters = obj.filters;
    this.performanceChartIds = obj.performanceChartIds;
    this.trendChartId = obj.trendChartId;
    this.currentChartId = obj.currentChartId;
    this.pastChartId = obj.pastChartId;
    this.offset = obj.offset;
    this.notes = [];
    this.bigNumber = undefined;
    this.vCompare = undefined;
    this.progress = false;
    this.allChartsData = [];
    this.formatedFilterData = this.formatFilterData(parseJson(obj.filters));
    this.isPercentage = obj.isPercentage;
    this.isAnomalous = obj.isAnomalous ? 1 : 0;
    this.isStaleMetric = "";
    this.isPositive = obj.isPositive;
    this.lowerBound = obj.lowerBound;
    this.upperBound = obj.upperBound;
    this.owner = obj.owner;
    this.dataset = obj.dataset;
    this.freshness = obj.freshness;
    this.sla = obj.sla;
    this.time_stamp = obj.time_stamp;
    this.isHidden = obj.isHidden;
    this.message = obj.message;

    if (obj.notes && obj.notes.length > 0) {
      obj.notes.forEach((eachNote) => {
        let formatedDate = dateUtility(eachNote.updatedAt);
        this.notes.push({
          id: eachNote.id,
          text: eachNote.text,
          updatedAt: eachNote.updatedAt,
          dateOut: {
            date: formatedDate.date,
            month: formatedDate.month,
          },
          snapshotDetail: eachNote.snapshotDetail,
          offset: eachNote.offset,
        });
      });
    }
    //if (this.notes.length > 0) this.notes = this.sortNotes(this.notes);
  }
  public static createTakeNotes(data: any) {
    return new NoteModel(data);
  }
  public setNumbers(timeTab): void {
    const bigNumber = safeGet(this.allChartsData, `data[0].data.data.data[0][0]`, 0);
    const vCompare = safeGet(this.allChartsData, `data[1].data.data.data[0].[0]`);
    this.bigNumber = !IsTabHidden(this.isHidden, timeTab)
      ? this.isPercentage
        ? abbreviateNumber(bigNumber).concat("%")
        : abbreviateNumber(bigNumber)
      : "-";
    const vCompValue = this.isPercentage
      ? bigNumber - vCompare
      : vCompare === 0
      ? 100
      : ((bigNumber - vCompare) * 100) / vCompare;
    this.vCompare = abbreviateNumber(vCompValue);
    this.progress = bigNumber - vCompare > 0;
    const cPrefix = this.isPercentage ? comparePrefixPercent : comparePrefix;
    const isPastNumberPresent = safeGet(this.allChartsData, `data[1].data.data.data[0].[0]`, false) !== false;

    this.vCompare = !IsTabHidden(this.isHidden, timeTab)
      ? isPastNumberPresent
        ? this.vCompare.concat(cPrefix[timeTab])
        : ""
      : "--";
    this.successful = safeGet(this.allChartsData, `data[0].data.data.data[0][0]`, false) !== false;
    this.isAnomalous = vCompValue < this.lowerBound || vCompValue > this.upperBound ? 2 : this.isAnomalous ? 1 : 0;
  }
  public sortNotes(formatData: Notes[]): Notes[] {
    var newformattedArr: Notes[] = formatData.sort((a, b) => {
      if (a.offset > b.offset) return 1;
      else return -1;
    });
    return newformattedArr;
  }
  public setChartsData(data: IChartData[]): void {
    this.allChartsData = data;
  }
  public formatFilterData = (data: any): string => {
    let lineData: any = [];
    data.length > 0 &&
      data.forEach((curr) => {
        if (typeof curr.value === "string") {
          lineData.push(curr.value);
        } else if (Array.isArray(curr.value)) {
          if (curr.value.length > 0) lineData.push(curr.value.join(" | "));
        }
      });
    return lineData.join(" | ");
  };

  public static prepareChartdata(data, tab: string, filterConfig) {
    return [
      {
        metric_id: data.id,
        slice_id: data.currentChartId,
        time_view: "currentChart",
        filters: {
          adhoc_filters: parseJson(data.filters),
          chronic_filters: MetricOperations.parseChronicFilter(filterConfig, tab, "currentChart"), //MetricOperations.chronicFilterValues[tab]
        },
      },
      {
        metric_id: data.id,
        slice_id: data.pastChartId,
        time_view: "pastChart",
        filters: {
          adhoc_filters: parseJson(data.filters),
          chronic_filters: MetricOperations.parseChronicFilter(filterConfig, tab, "pastChart"), //MetricOperations.pastChronicFilterValues[tab]
        },
      },
    ];
  }
  public static prepareAPICallData(data: INote): IPrepareDataAPICall {
    let formNotes = [] as any;
    formNotes = data.notes.map((note) => {
      return {
        text: note.text,
        updatedAt: note.updatedAt,
        id: note.id,
        snapshotDetail: note.snapshotDetail,
        offset: note.offset,
      };
    });

    const { id, label, filters, performanceChartIds, currentChartId, pastChartId, offset, trendChartId } = data;

    return {
      id,
      label,
      filters,
      performanceChartIds,
      currentChartId,
      pastChartId,
      offset,
      trendChartId,
      notes: formNotes,
    };
  }
}
